module.exports = __webpack_public_path__ + "static/media/female.1777ef0a.png";